import React, { useEffect, useState } from 'react';
import Grid from '@mui/material/Grid2';
import { useFormik } from 'formik';
import dayjs from 'dayjs';
import CustomTextFieldWithIcon from '../../../../Components/custom_components/custom_text_field/CustomTextFieldWithIcon';
import CustomDatePicker from '../../../../Components/custom_components/CustomDatePicker/CustomDatePicker';
import CustomBreadcrumbs from '../../../../Components/custom_components/CustomBreadcrumbs/CustomBreadcrumbs';
import ActionButton from '../../../../Components/custom_components/CustomButtons/ActionButton/ActionButton';
import { get_worksite_with_out_pagination } from '../../../../config/Worksite/siteApis';
import { get_technology_with_out_pagination } from '../../../../config/Resource/technologyApis';
import CustomSelectDropdown from '../../../../Components/custom_components/CustomSelectDropdown/CustomSelectDropdown';
import { get_report_status } from '../../../../config/GeneralApis/GeneralApis';

function BinReportSearchFilter({ tableTitle, searchFilter, on_change_value, on_page_count_update }) {


    const [technologyListing, setTechnologyListing] = useState([]);
    const [worksiteListing, setWorksiteListing] = useState([]);
    // const [workforceListing, setWorkforceListing] = useState([]);
    // const [equipmentListing, setEquipmentListing] = useState([]);
    const [statusOptions, setStatusOptions] = useState([]);

    const fetchTechnologies = async () => {
        try {
            const response = await get_technology_with_out_pagination();
            if (response?.status === "success") {
                // Transform data into the desired format with label and value
                const transformedData = response.data.data?.map((item) => ({
                    label: item?.TechnologiesName,
                    value: item?.TechnologiesTypeId
                }));

                // Set the transformed data to the state
                setTechnologyListing(transformedData || []);
            } else {
                setTechnologyListing([]);
            }
        } catch (error) {
            console.error('Error fetching technologies:', error);
            setTechnologyListing([]);
        }
    };

    // FETCH WORKSITES 
    const fetchSites = async () => {
        try {
            const response = await get_worksite_with_out_pagination();

            if (response?.status === "success") {
                // Transform data into the desired format with label and value
                const transformedData = response.data.data?.map((item) => ({
                    label: item?.worksiteName,
                    value: item?.WorksiteID
                }));

                // Set the transformed data to the state
                setWorksiteListing(transformedData || []);
            } else {
                setWorksiteListing([]);
            }
        } catch (error) {
            console.error('Error fetching :', error);
            setWorksiteListing([]);
        }
    };

    // REPORT STATAUS
    const fetchReportStatus = async () => {
        try {
            const response = await get_report_status();
            if (response?.status === "success") {
                const transformedData = response.data?.map(item => ({
                    label: item?.process,
                    value: item?.id,
                }));

                const customAllField = [{
                    label: 'All',
                    value: '',
                }]
                const customStatusArray = [...customAllField, ...transformedData];
                setStatusOptions(customStatusArray);
            } else {
                setStatusOptions([]);
            }
        } catch (error) {
            console.error("Error fetching report status:", error);
            setStatusOptions([]);
        }
    };

    // FOR GET TECHNOLOGIES FROM LIST
    useEffect(() => {
        fetchReportStatus()
        // fetchTechnologies();
    }, []);


    const formik = useFormik({
        initialValues: {
            reportName: '',
            startDate: '',
            endDate: '',
            scheduleCode: '',
            technology: '',
            worksite: '',
            project: '',
            status: ''
        },
    });

    const resetFilter = () => {
        formik.resetForm();
        on_change_value(1)
        on_page_count_update(25)
        searchFilter(
            {
                reportName: '',
                startDate: '',
                endDate: '',
                scheduleCode: '',
                technology: '',
                worksite: '',
                project: '',
                status: ''
            }
        )
    }

    const breadcrumbs = ['Schedules', tableTitle]

    return (

        <div className="schedule-search-filter-container">
            <div className="schedule-search-filter-sub-container">
                <div className="schedule-search-filter-header">
                    <div className="schedule-search-filter-left">
                        <div className="schedule-table-title">{tableTitle}</div>
                        <CustomBreadcrumbs breadcrumbs={breadcrumbs} />
                    </div>
                </div>

                <div className="search-layout-wrapper">
                    {/* Filters Section */}
                    <div className="search-filter-container">
                        <div className="search-inputs-fields">
                            <Grid item xs={12} sm={6} md={2}>
                                <CustomTextFieldWithIcon
                                    name="reportName"
                                    placeholder="Enter Report Name"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.reportName}
                                    width="200px"
                                />
                            </Grid>

                            <Grid item xs={12} sm={6} md={2}>
                                <CustomTextFieldWithIcon
                                    name="scheduleCode"
                                    placeholder="Enter scheduleCode "
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.scheduleCode}
                                    width="200px"
                                />
                            </Grid>

                            {/* 
                            <Grid item xs={12} sm={6} md={2}>
                                <CustomSelectDropdown
                                    name="scheduleID"
                                    placeholder="Select Technology"
                                    options={technologyListing}
                                    value={technologyListing.find((tech) => tech.value === formik.values.scheduleID) || ""}
                                    onChange={(selectedOption) => {
                                        formik.setFieldValue("scheduleID", selectedOption ? selectedOption.value : "");
                                    }}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.scheduleID && Boolean(formik.errors.scheduleID)}
                                    helperText={formik.touched.scheduleID && formik.errors.scheduleID}
                                    isDisabled={false}
                                    isMulti={false}
                                    width="200px"
                                />
                            </Grid> */}

                            {/* <Grid item xs={12} sm={6} md={2}>
                                <CustomSelectDropdown
                                    name="WorksiteId"
                                    placeholder="Select Worksite"
                                    options={worksiteListing}
                                    value={worksiteListing.find((w) => w.value === formik.values.WorksiteId) || ""}
                                    onChange={(selectedOption) => {
                                        formik.setFieldValue("WorksiteId", selectedOption ? selectedOption.value : "");
                                    }}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.WorksiteId && Boolean(formik.errors.WorksiteId)}
                                    helperText={formik.touched.WorksiteId && formik.errors.WorksiteId}
                                    isDisabled={false}
                                    isMulti={false}
                                    width="200px"
                                />
                            </Grid> */}

                            {/* <Grid item xs={12} sm={6} md={2}>
                                <CustomSelectDropdown
                                    name="status"
                                    placeholder="Select Status"
                                    options={moveToClientStatus}
                                    value={
                                        moveToClientStatus?.find(option => option?.value === formik?.values?.status) ||
                                        moveToClientStatus?.find(option => option?.value === 0)
                                    }
                                    onChange={(selectedOption) => {
                                        formik.setFieldValue("status", selectedOption ? selectedOption.value : 0);
                                        searchFilter({ ...formik.values, status: selectedOption ? selectedOption.value : 0 });
                                        handleClearSelectedIds()

                                    }}
                                    onBlur={formik.handleBlur}
                                    isDisabled={false}
                                    isClearable={false} // Set to false for not clearable the value
                                    width="250px"
                                />
                            </Grid> */}



                            <Grid item xs={12} sm={6} md={2}>
                                <CustomTextFieldWithIcon
                                    name="worksite"
                                    placeholder="Enter Worksite "
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.worksite}
                                    width="200px"
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={2}>
                                <CustomTextFieldWithIcon
                                    name="project"
                                    placeholder="Enter Project "
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.project}
                                    width="200px"
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={2}>
                                <CustomTextFieldWithIcon
                                    name="technology"
                                    placeholder="Enter Technology "
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.technology}
                                    width="200px"
                                />
                            </Grid>

                            <Grid item xs={12} sm={6} md={2}>
                                <CustomSelectDropdown
                                    name="status"
                                    placeholder="Select Status"
                                    options={statusOptions}
                                    value={
                                        statusOptions?.find(option => option?.value === formik?.values?.status) ||
                                        statusOptions?.find(option => option?.value == "")
                                    }
                                    onChange={(selectedOption) => {
                                        formik.setFieldValue("status", selectedOption ? selectedOption.value : "");
                                    }}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.status && Boolean(formik.errors.status)}
                                    helperText={formik.touched.status && formik.errors.status}
                                    isMulti={false}
                                    width="100%"
                                />
                            </Grid>

                            <Grid item xs={12} sm={6} md={2}>
                                <CustomDatePicker
                                    name="startDate"
                                    label="From Date"
                                    onChange={(date) => {
                                        formik.setFieldValue("startDate", date);
                                    }}
                                    onBlur={formik.handleBlur}
                                    value={dayjs(formik.values.startDate, "DD-MM-YYYY")}
                                    width="200px"
                                />
                            </Grid>

                            <Grid item xs={12} sm={6} md={2}>
                                <CustomDatePicker
                                    name="endDate"
                                    label="End Date"
                                    onChange={(date) => {
                                        formik.setFieldValue("endDate", date);
                                    }}
                                    onBlur={formik.handleBlur}
                                    value={dayjs(formik.values.endDate, "DD-MM-YYYY")}
                                    minDate={dayjs(formik.values.startDate, "DD-MM-YYYY")} // Set minimum date

                                    width="200px"
                                />
                            </Grid>

                        </div>

                        <div className="search-buttons-fixed-right">
                            <ActionButton
                                onClick={() => {
                                    on_change_value(1)
                                    searchFilter({ ...formik.values }); // Always trigger search, even if no values changed
                                }}
                                btnDisable={false}
                                label="Search"
                                btnType="primary"
                            />
                            <ActionButton label="Reset" btnType="outlined" onClick={resetFilter} />
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
}

export default BinReportSearchFilter;


// <div className="search-filter-container">
//         <div className="search-inputs">
//             <Grid item xs={12} sm={6} md={2}>
//                 <CustomTextFieldWithIcon
//                     name="reportName"
//                     placeholder="Enter Schedule Code"
//                     onChange={formik.handleChange}
//                     onBlur={formik.handleBlur}
//                     value={formik.values.reportName}
//                 />
//             </Grid>

//             <Grid item xs={12} sm={6} md={2}>
//                 <CustomSelectDropdown
//                     name="scheduleID"
//                     placeholder="Select Technology"
//                     options={technologyListing}
//                     value={technologyListing.find((tech) => tech.value === formik.values.scheduleID) || ""}
//                     onChange={(selectedOption) => {
//                         formik.setFieldValue("scheduleID", selectedOption ? selectedOption.value : "");
//                     }}
//                     onBlur={formik.handleBlur}
//                     error={formik.touched.scheduleID && Boolean(formik.errors.scheduleID)}
//                     helperText={formik.touched.scheduleID && formik.errors.scheduleID}
//                     isDisabled={false}
//                     isMulti={false}
//                 />
//             </Grid>

//             <Grid item xs={12} sm={6} md={2}>
//                 <CustomSelectDropdown
//                     name="WorksiteId"
//                     placeholder="Select Worksite"
//                     options={worksiteListing}
//                     value={worksiteListing.find((w) => w.value === formik.values.WorksiteId) || ""}
//                     onChange={(selectedOption) => {
//                         formik.setFieldValue("WorksiteId", selectedOption ? selectedOption.value : "");
//                     }}
//                     onBlur={formik.handleBlur}
//                     error={formik.touched.WorksiteId && Boolean(formik.errors.WorksiteId)}
//                     helperText={formik.touched.WorksiteId && formik.errors.WorksiteId}
//                     isDisabled={false}
//                     isMulti={false}
//                 />
//             </Grid>

//             <Grid item xs={12} sm={6} md={2}>
//                 <CustomDatePicker
//                     name="startDate"
//                     label="From Date"
//                     onChange={(date) => {
//                         formik.setFieldValue("startDate", date);
//                     }}
//                     onBlur={formik.handleBlur}
//                     value={dayjs(formik.values.startDate, "DD-MM-YYYY")}
//                 />
//             </Grid>

//             <Grid item xs={12} sm={6} md={2}>
//                 <CustomDatePicker
//                     name="endDate"
//                     label="End Date"
//                     onChange={(date) => {
//                         formik.setFieldValue("endDate", date);
//                     }}
//                     onBlur={formik.handleBlur}
//                     value={dayjs(formik.values.endDate, "DD-MM-YYYY")}
//                 />
//             </Grid>
//         </div>

//         <div className="search-buttons-fixed-right">
//             <button className="search-btn">Search</button>
//             <button className="reset-btn">Reset</button>
//         </div>
//     </div>